import React from "react";
export function Td({ className = "", children }) {
    return <td className={"text-left px-2 py-2 relative " + className}>{children}</td>;
}
//# sourceMappingURL=td.jsx.map